module.exports = __webpack_public_path__ + "img/Market-launch-amico.056e496d.svg";